import TaxonomyCanvas from './TaxonomyCanvas';
import { ITaxonomyTag } from './taxonomy.compiled';

export { ITaxonomyTag };
export default TaxonomyCanvas;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TaxonomyCanvas/index.ts